import * as H from 'history';

export enum RoutePaths {
  LANDING = '/payment',
  POLICY_PAYMENT = '/payment/policy',
  MAKE_PAYMENT = '/payment/pay',
  CONFIRMATION = '/payment/confirm',
  ERROR = '/payment/error',
}

export const getNextPage = (currentPath: String) => {
  switch (currentPath) {
    case RoutePaths.LANDING:
      return RoutePaths.POLICY_PAYMENT;
    case RoutePaths.POLICY_PAYMENT:
      return RoutePaths.MAKE_PAYMENT;
    case RoutePaths.MAKE_PAYMENT:
      return RoutePaths.CONFIRMATION;
    default:
      return undefined;
  }
};

export const getPreviousPage = (currentPath: string) => {
  switch (currentPath) {
    case RoutePaths.MAKE_PAYMENT:
      return RoutePaths.POLICY_PAYMENT;
    case RoutePaths.ERROR:
      return RoutePaths.LANDING;
    default:
      return undefined;
  }
};

export const isConfirmationPage = (currentPath: string): boolean =>
  currentPath === RoutePaths.CONFIRMATION;

export const isSystemErrorPage = (currentPath: string): boolean =>
  currentPath === RoutePaths.ERROR;

export const isLandingPage = (currentPath: string): boolean =>
  currentPath === RoutePaths.LANDING;

// Specifying the number of back pages to 2 so that customers
// are returned to the page they were browsing before they accessed
// the payment portal when they use the browser back button twice.
// May need to implement better solution.

export const onBackGoToLanding = (
  history: H.History,
  numberPagesBack: number = -2
) =>
  history.listen(() => {
    if (
      history.action === 'POP' &&
      history.location.pathname !== RoutePaths.LANDING
    ) {
      history.go(numberPagesBack);
    }
  });
